import { html, css } from 'lit'
import { i18next } from '@operato/i18n'

import { FieldRenderer } from '../types.js'

const STYLE = css`
  .secret-container {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
  }

  .secret-value {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: var(--md-sys-color-on-background);
    font-family: inherit;
    font-size: inherit;
    letter-spacing: 0.5px;
  }

  .secret-toggle {
    position: absolute;
    right: 4px;
    cursor: pointer;
    font-size: 16px;
    color: var(--md-sys-color-on-surface-variant);
    user-select: none;
    opacity: 0.7;
    transition: opacity 0.2s;
  }

  .secret-toggle:hover {
    opacity: 1;
    color: var(--md-sys-color-primary);
  }

  .secret-container:hover .secret-toggle {
    opacity: 1;
  }
`

export const OxGristRendererSecret: FieldRenderer = (value, column, record, rowIndex, field) => {
  if (!value) {
    return html`<span>-</span>`
  }

  const toggleVisibility = (event: Event) => {
    event.stopPropagation()

    const container = (event.target as HTMLElement).closest('.secret-container')
    const valueSpan = container?.querySelector('.secret-value') as HTMLElement
    const icon = event.target as HTMLElement

    if (!valueSpan || !icon) return

    if (valueSpan.textContent === '••••••••••••••••') {
      valueSpan.textContent = value
      icon.textContent = 'visibility'
      icon.title = i18next.t('text.input-secret-hide')
    } else {
      valueSpan.textContent = '••••••••••••••••'
      icon.textContent = 'visibility_off'
      icon.title = i18next.t('text.input-secret-show')
    }
  }

  return html`
    <style>
      ${STYLE}
    </style>
    <div class="secret-container">
      <span class="secret-value" title=${i18next.t('text.input-secret-placeholder')}>••••••••••••••••</span>
      <md-icon class="secret-toggle" @click=${toggleVisibility} title=${i18next.t('text.input-secret-toggle')}>
        visibility_off
      </md-icon>
    </div>
  `
}
